import request from '@/utils/request'
import { ouchnSource } from '@/service'

// 获取STS临时key
export async function getOssSTSCredentials() {
  return request({
    url: ouchnSource + '/file/getOssSTSCredentials',
    method: 'get',
    // params: {isReadPublic,dir}
  })
}